export default __webpack_public_path__ + "static/media/defensivestance.0ab476d1.png";